import { render } from "./CommandCenter.vue?vue&type=template&id=c50f77e2&scoped=true"
import script from "./CommandCenter.vue?vue&type=script&lang=js"
export * from "./CommandCenter.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./CommandCenter.vue?vue&type=style&index=1&id=c50f77e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50f77e2"]])

export default __exports__